import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../form/errorMsg";
import "../support/reportIssueModal.css";
import { useDispatch } from "react-redux";
import { verifyReportModal } from "../../../redux/actions/customerVerificationActions";
import { useNavigate } from "react-router-dom";
import InputField from "../../form/inputField/inputField";
import Select from "react-select";

const ApproveRequestModal = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const [radioActive, setradioActive] = useState("doctor");
  const [successModal, setSuccessModal] = useState(false);
  const [mailData, setMailData] = useState("");
  const dispatch = useDispatch();

  const initialValues = {
    issues: [],
  };

  const validationSchema = Yup.object().shape({
    issues: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
  });

  const onSubmit = (values) => {
    // dispatch(verifyReportModal(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    handleClose();
    setSuccessModal(true);
    setMailData(data.data.data);
    setTimeout(timeOutFnc, 3000);
  };

  const timeOutFnc = () => {
    setSuccessModal(false);
    // navigate("/support/customer-verification");
  };

  const onError = (err) => {
    console.log(err.data);
  };
  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        contentClassName="report-verify-modal"
      >
        <div className="m-4">
          <ModalBody>
            <div>
              <label className="fn_Nunito fs_20 fw_700 w-100">
                Approve Request
              </label>
            </div>
            <div>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({ setFieldValue, values }) => (
                  <Form>
                    <div className="my-2">
                      <InputField
                        id={"doctor_basic_details.name"}
                        label={"Head Quarter"}
                        type={"text"}
                        placeholder={"Type to search Headquarters"}
                        name="doctor_basic_details.name"
                        value={""}
                      />
                    </div>
                    <div className="my-2">
                      <InputField
                        id={"doctor_basic_details.name"}
                        label={"Division Requested For"}
                        type={"text"}
                        placeholder={"Division Name Goes Here"}
                        name="doctor_basic_details.name"
                        value={""}
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AdminButton
                        width="266px"
                        height="52px"
                        type="button"
                        color="#FF6F5B"
                        border="1px solid #FF6F5B"
                        onClick={() => handleClose()}
                      >
                        <span className="m-2">CANCEL</span>
                      </AdminButton>
                      <AdminButton
                        width="266px"
                        height="52px"
                        type="submit"
                        background="#2AD3E7"
                        border-radius="5px"
                        color="white"
                        marginRight="0px"
                      >
                        Approve
                      </AdminButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default ApproveRequestModal;

const fieldForceOptions = [
  {
    label: "Jivini",
    value: "Jivini",
  },
  {
    label: "customStyles",
    value: "customStyles",
  },
  {
    label: "fieldForceOptions",
    value: "fieldForceOptions",
  },
];

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "450px",
    height: "40px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
